import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// 全局注册axios，方便组件中使用this.$http
Vue.prototype.$http = axios

// 关闭生产环境提示
Vue.config.productionTip = false

// 创建Vue实例
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')
